import LazyLoad from './global/lazy-section-js.js'
import Media from './media.js'
import VideoMediaParser from "./video-media-parser.js";
import IframeMediaParser from "./iframe-media-parser.js";
import Header from "./global/header.js";
import Cart from "./global/cart.js";
import ProductCard from "./product-card.js";
import PredictiveSearch from "./predictive-search.js";
import SearchSlider from "./search-slider.js";


const events = [
  'DOMContentLoaded',
  'shopify:inspector:activate',
  'shopify:inspector:deactivate',
  'shopify:section:load',
  'shopify:section:unload',
  'shopify:section:select',
  'shopify:section:deselect',
  'shopify:section:reorder',
  'shopify:block:select',
  'shopify:block:deselect',
]

events.forEach(event => {
  window.addEventListener(event, () => {

    LazyLoad().init()
    VideoMediaParser().init()
    IframeMediaParser().init()
    Media().init()
    SearchSlider().init()
    Header().init()
    Cart().init()
    ProductCard().init()
    PredictiveSearch().init()
    
  })
})
